module.exports = __webpack_public_path__ + "static/courthouse-90dbcab78680f24017d4fb04f79d2b88.jpg";